<template>
    <div>
        <productcontent></productcontent>
    </div>
</template>

<script>
import productcontent from "@/components/contentcoms/prodecutcontentcoms/productcontent"
export default {
    components:{
        productcontent:productcontent
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/product.vue